class ProductReviews extends HTMLElement {
  static observedAttributes = ["data-modal-open"];

  constructor() {
    super();
    this.product = this.dataset.handle;
    this.dialog = null;
    this.blockquote = this.querySelector("blockquote");
    this.showModalFromProductTemplate = document.querySelector("[data-show-rating-modal]");
    this.showModalButton = this.querySelector("[data-show-modal]");
    this.currentPage = 1;
    this.pages = this.dataset.pages;
    this.nextPageUrl = this.dataset.nextPageUrl;
  }

  connectedCallback() {
    this.showModalButton.addEventListener("click", () => {
      this.createModal();
    });
    this.showModalFromProductTemplate.addEventListener("click", () => {
      this.createModal();
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-modal-open" && newValue === "true") {
      const endOfList = document.querySelector(
        "[data-testimonials] #end-of-list"
      );
      const parentContainer = endOfList.parentNode;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.currentPage == this.pages) {
              parentContainer.removeChild(endOfList);
              observer.unobserve(endOfList);
              this.currentPage = 1;
            } else {
              this.currentPage += 1;
              fetch(
                `${window.location.pathname}?view=testimonials&page=${this.currentPage}`
              )
                .then((response) => response.text())
                .then((html) => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, "text/html");
                  parentContainer.insertBefore(doc.body, endOfList);
                });
            }
          }
        });
      });
      observer.observe(endOfList);
    }
  }

  async createModal() {
    await fetch(`${window.location.pathname}?view=testimonials-dialog`)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const dialog = parser.parseFromString(html, "text/html");
        document.body.appendChild(dialog.body.firstChild);
        const modal = document.querySelector("[data-testimonials");
        modal.showModal();
        this.dataset.modalOpen = true;
        freezeBody(true);
        modal.addEventListener("close", () => {
          modal.remove();
          this.dataset.modalOpen = false;
          freezeBody(false);
        });
      });
  }
}

customElements.define("product-reviews", ProductReviews);
